import { useEffect } from "react";

function setMeta(name, content, attr = "name") {
    if (!content) return;
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setJsonLd(id, data) {
    let el = document.getElementById(id);
    if (data == null) {
        if (el) el.remove();
        return;
    }
    if (!el) {
        el = document.createElement("script");
        el.type = "application/ld+json";
        el.id = id;
        document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
}

export function useSeo({ title, description, canonical, jsonLd }) {
    useEffect(() => {
        if (title) document.title = title;
        setMeta("description", description);
        setMeta("og:title", title, "property");
        setMeta("og:description", description, "property");
        setMeta("og:type", "website", "property");
        setMeta("twitter:card", "summary_large_image");
        const path = canonical || window.location.href;
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.rel = "canonical";
            document.head.appendChild(link);
        }
        link.href = path;
        setJsonLd("sudigi-jsonld", jsonLd || null);
    }, [title, description, canonical, jsonLd]);
}

export const ORG_JSONLD = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "SUDIGI",
    description: "Affordable digital marketing and business growth services for Indian businesses.",
    slogan: "Digital Marketing. Simplified. Affordable. Result-Focused.",
    areaServed: "IN",
};
